/**
 * @module
 * @format
 */

import {reactive} from 'nova';
/**
 * @import {Amateur} from '../amateurPool/model/amateur.js';
 * @import {AmateurIsData} from 'acng/model/amateur.js';
 */
import {isOnline} from '../amateurPool/service/online.js';

/**
 * @implements {AmateurIsData}
 */
class AmateurIs {
  @reactive accessor online = false;
  @reactive accessor offline = false;

  /**
   * @param {Amateur} amateur
   */
  constructor(amateur) {
    if (isOnline(amateur.id)) {
      this.online = true;
    } else {
      this.offline = true;
    }
  }
}

class AmateurHas {
  //
}

export {
  //
  AmateurIs,
  AmateurHas,
};
